import React from "react";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import checkImage from "../assets/check.png";
import "./process-detail/styles.scss";

const Finished = () => {
  const { t } = useTranslation();

  return (
    <div className="interview-finished">
      <Card
        className="card"
        title={
          <div style={{ textAlign: "center" }}>
            <img
              width="60"
              src={checkImage}
              alt="Genoma - Video entrevista finalizada"
              style={{ marginBottom: 20 }}
            />
            <h1>{t("frontvint__finished_title")}</h1>
            <p>{t("frontvint__finished_subtitle")}</p>
          </div>
        }
      >
        <span>{t("frontvint__finished_content")}</span>
      </Card>
    </div>
  );
};

export default Finished;
